module.exports = __webpack_public_path__ + "img/beachvolleyball-dark.9cc2bab5.svg";